import _Select from "antd/es/select";
var _excluded = ["bottomRight", "searchable", "fixedSelectLabel", "dropdownClassName", "showArrow", "className", "listHeight", "suffixIcon"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useRef } from 'react';
import SLSymbolIcon from '../OneSymbolIcon';
import cs from 'classnames';
import './index.less';
/**
 * import { OneSelect } from '@yy/one-ui'
 */
var OneSelect = function OneSelect(props) {
  var bottomRight = props.bottomRight,
    searchable = props.searchable,
    fixedSelectLabel = props.fixedSelectLabel,
    dropdownClassName = props.dropdownClassName,
    showArrow = props.showArrow,
    className = props.className,
    listHeight = props.listHeight,
    suffixIcon = props.suffixIcon,
    rest = _objectWithoutProperties(props, _excluded);
  var iconRef = useRef();
  useEffect(function () {
    if ((iconRef === null || iconRef === void 0 ? void 0 : iconRef.current) && fixedSelectLabel) {
      var _iconRef$current, _iconRef$current$pare;
      var fixedLabelParentNode = (_iconRef$current = iconRef.current) === null || _iconRef$current === void 0 ? void 0 : (_iconRef$current$pare = _iconRef$current.parentNode) === null || _iconRef$current$pare === void 0 ? void 0 : _iconRef$current$pare.previousSibling;
      var fixedLabelSpan = fixedLabelParentNode.querySelector('.one-select-selection-placeholder');
      if (!fixedLabelSpan) {
        fixedLabelSpan = document.createElement('span');
        fixedLabelSpan.setAttribute('class', cs('one-select-selection-placeholder', !props.mode && 'ant-select-selection-placeholder'));
        fixedLabelSpan.innerHTML = fixedSelectLabel;
        fixedLabelParentNode.append(fixedLabelSpan);
      } else {
        fixedLabelSpan.innerHTML = fixedSelectLabel;
      }
    }
  }, [iconRef, fixedSelectLabel, props.mode]);
  return /*#__PURE__*/React.createElement(_Select, _extends({}, rest, {
    showArrow: showArrow !== null && showArrow !== void 0 ? showArrow : true,
    listHeight: listHeight || 334,
    dropdownClassName: cs(dropdownClassName, 'one-select-dropdown', fixedSelectLabel && 'one-select-dropdown-label-fixed'),
    dropdownAlign: bottomRight ? {
      points: ['tr', 'br']
    } : undefined,
    className: cs('one-select', className, fixedSelectLabel && 'one-select-label-fixed', searchable && 'one-select-searchable'),
    suffixIcon: /*#__PURE__*/React.createElement("div", {
      ref: iconRef
    }, suffixIcon || /*#__PURE__*/React.createElement(SLSymbolIcon, {
      icon: "icon-chevron-down"
    }))
  }));
};
OneSelect.Option = _Select.Option;
OneSelect.OptGroup = _Select.OptGroup;
export default OneSelect;